import { themeColors } from "../../config";
const styles = {
  manuBar: {
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    backgroundColor: themeColors.transparentBlack,
  },
  component: {
    flex: 1,
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    fontFamily: "orbitron",
    fontSize: 15,
    overflow: "hidden",
  },
  optionBtn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    flex: 1,
    borderRadius: 0,
    fontSize: 12,
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
  },
  full: {
    display: "flex",
    position: "absolute",
    flexDirection: "column",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    overflow: "auto",
  },
  alarmRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    alignSelf: "stretch",
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
    border: "1px solid rgba(255,255,255,0.5)",
  },
  alarmText: {
    fontSize: 25,
    margin: 10,
  },
  alarmBtn: {
    display: "flex",
    flexDirection: "row",
  },
};
export default styles;
